import { EnvelopeIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import CT from '@marketplace-ai/tags';
import { ActorRefFrom } from 'xstate';
import { employerSignupSkipsApproval } from '../approval';
import { employerRegistrationView } from '../registration-view.machine';

interface Props {
  actorRef: ActorRefFrom<typeof employerRegistrationView>;
  loading?: boolean;
}

export const PendingVerification = ({ actorRef }: Props) => {
  const handleBypassApproval = () => {
    actorRef.send({ type: 'ON_BYPASS_APPROVAL' });
  };

  // [MCV-1957] Prod creates the employer when the facility step is submitted, so it only
  // reaches this screen when that failed. Nothing was saved, and the details are still in
  // the form, so it offers a retry rather than promising an approval email.
  if (employerSignupSkipsApproval()) {
    return (
      <div
        data-cy={CT.employer.verification.pendingVerificationMsg}
        className="flex flex-col items-center justify-center h-[500px]"
      >
        <ExclamationTriangleIcon className="h-20 w-20 text-primary-t-50 mb-5" />
        <h1 className="heading-large mb-5">We could not create your account</h1>
        <p className="sub-heading">
          Your details are still here. Try again, or contact support if it keeps failing.
        </p>
        <button
          onClick={handleBypassApproval}
          className="mt-6 px-4 py-2 bg-primary-50 hover:bg-primary-100 text-white rounded-control text-sm font-medium"
        >
          Try again
        </button>
      </div>
    );
  }

  return (
    <div
      data-cy={CT.employer.verification.pendingVerificationMsg}
      className="flex flex-col items-center justify-center h-[500px]"
    >
      <EnvelopeIcon className="h-20 w-20 text-primary-t-50 mb-5" />
      <h1 className="heading-large mb-5">Account Pending Approval</h1>
      <p className="sub-heading">
        Your Account has been requested and is pending approval. You will receive an email when your
        account is approved.
      </p>
      {/* This button is the only way an employer registration is created outside prod:
          nothing is sent to the server until it is clicked. Prod never shows it (see
          employerSignupSkipsApproval). */}
      <button
        onClick={handleBypassApproval}
        className="mt-6 px-4 py-2 bg-warning hover:bg-warning-800 text-white rounded-control text-sm font-medium"
      >
        Bypass Approval (Dev Only)
      </button>
    </div>
  );
};
